import { space } from './space';

export const sizes = { full: '100%', ...space } as const;
